import type { PipeIntegration, PipeIntegrationDef } from '../index'

/**
 * BUILD_SETTINGS decides how a release is built, so this module is deliberately empty:
 * builder/nuxt.config.ts reads the winning row before Vite starts and changes the build
 * itself — `legacyBrowsers` through builder/lib/legacyBrowsers.ts, `loadingOverlay`
 * through builder/lib/loadingOverlay.ts, which puts markup outside the app that
 * builder/app/app.vue takes away. Validated by `BuildSettingsIntegrationConfigDto` on the
 * API. Dependency-free so the builder can import it in Node.
 */

/** Registry key and API type of the integration that carries the build's settings. */
export const BUILD_SETTINGS_INTEGRATION_TYPE = 'BUILD_SETTINGS'

/** Stored shape of a BUILD_SETTINGS row's config (the API's `BuildSettingsIntegrationConfigDto`). */
export interface BuildSettingsIntegrationConfig {
  /** Also build for the engines in LEGACY_BROWSER_FLOOR. */
  legacyBrowsers?: boolean
  /** Cover each page from the first paint until it is ready to use (builder/lib/loadingOverlay.ts). */
  loadingOverlay?: boolean
}

/**
 * The oldest engines a `legacyBrowsers` build runs on: the first to load ES modules with
 * dynamic import, which every built pipe is. Anything older would need a separate
 * `nomodule` bundle, and no browser on Android 13/14 is that old.
 */
export const LEGACY_BROWSER_FLOOR = {
  chrome: 64,
  safari: 12,
  ios: 12,
  firefox: 67,
  edge: 79,
} as const

const buildSettingsIntegration: PipeIntegration = (): PipeIntegrationDef => ({})

export default buildSettingsIntegration
